module.exports = __webpack_public_path__ + "static/img/pc_pd_v2_5.23a4aab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pic/pc_pd_v2_5.png
// module id = lWJN
// module chunks = 0